import useAskTurn from '@/hooks/useAskTurn';
import { useAppSelector } from '@/utils/redux';
import { selectLatestAskArgs } from '@/utils/slices/askSlice';

/**
 * The latest Ask AllTrails question and its response. The sidebar and the map both call this, so they share one request.
 */
const useAskResponse = () => useAskTurn(useAppSelector(selectLatestAskArgs));

export default useAskResponse;
